import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const List = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
             d="M6.5 12.5C7.32843 12.5 8 11.8284 8 11C8 10.1716 7.32843 9.5 6.5 9.5C5.67157 9.5 5 10.1716 5 11C5 11.8284 5.67157 12.5 6.5 12.5Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd" 
            d="M11 10C10.4477 10 10 10.4477 10 11C10 11.5523 10.4477 12 11 12C11 12 11 12 11 11V12H33C33.5523 12 34 11.5523 34 11C34 10.4477 33.5523 10 33 10H11ZM11 11C11 10 11 10 11 10V11Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd" 
            d="M11 19C10.4477 19 10 19.4477 10 20C10 20.5523 10.4477 21 11 21H35C35.5523 21 36 20.5523 36 20C36 19.4477 35.5523 19 35 19H11Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
             d="M11 28C10.4477 28 10 28.4477 10 29C10 29.5523 10.4477 30 11 30H29C29.5523 30 30 29.5523 30 29C30 28.4477 29.5523 28 29 28H11Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd" 
            d="M8 20C8 20.8284 7.32843 21.5 6.5 21.5C5.67157 21.5 5 20.8284 5 20C5 19.1716 5.67157 18.5 6.5 18.5C7.32843 18.5 8 19.1716 8 20Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd" 
            d="M6.5 30.5C7.32843 30.5 8 29.8284 8 29C8 28.1716 7.32843 27.5 6.5 27.5C5.67157 27.5 5 28.1716 5 29C5 29.8284 5.67157 30.5 6.5 30.5Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default List;
